export const loadLocales = async (lang) => {
  const { default: result } = await import(
    `assets/locales/${lang}/general.json`
  )

  return {
    ...result,
  }
}
